import React, { useEffect, useState } from "react";
import MyAccount from "./MyAccount";
import EditAccount from "./EditAccount";
import { capitalize } from "../../../utils";
import BreadCrumb from "../../../layout/BreadCrumb";
import { useDispatch, useSelector } from "react-redux";
import { getOrganizationDetails } from "../../../features/fetch/fetchSlice";

const CompanyAccount = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [isEdit, setIsEdit] = useState(false);
  const { refetchKey } = useSelector((state) => state.global);

  async function getOrganizationDetailsData() {
    await dispatch(
      getOrganizationDetails({ 
        url: "api/v1/org/fetch-organisation",
      })
    );
  }

  useEffect(() => {
    if (refetchKey == 1) {
      getOrganizationDetailsData();
    }
  }, [refetchKey]);


  useEffect(() => {
      getOrganizationDetailsData();
  }, []);
  return (
    <div>
      {isEdit ? (
        <EditAccount setIsEdit={setIsEdit} />
      ) : (
        <MyAccount setIsEdit={setIsEdit} />
      )}
    </div>
  );
};

export default CompanyAccount;
